<template>
  <input-form
    component-name="form-password-recovery"
    ref="tpl_root"
    :use-mandatory-fields-warning="false"
    :submit-title="$t.labels.proceed"
    :submit-callback="handleSubmit"
    :success-callback="handleSuccess"
    :success-message="$t.titles.password_recovery_check_mailbox"
    :value="initialValue"
    @update:value="handleUpdate"
  >
    <input-hidden
      v-if="userStore.logged"
      name="email"
      :value="userStore.user.email"
    />
    <input-email v-else class="w-full" />
  </input-form>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
const props = defineProps({
  variant: {
    type: String,
    required: true,
    validator: function (value) {
      return ["recovery", "change-request"].indexOf(value) !== -1;
    },
  },
});

const tpl_root = templateRef("tpl_root");
const nuxtApp = useNuxtApp();
const userStore = useUserStore();

const initialValue = ref({
  email: userStore.user.email,
  token: userStore.user.token,
});

function handleSuccess(data) {
  console.log("handleSuccess", data);
}

function handleUpdate(data) {
  console.log("handleUpdate", data);
}

async function handleSubmit(fields) {
  console.log("handleSubmit", { ...fields });

  const method =
    props.variant == "recovery"
      ? userStore.passwordRecoveryRequest
      : userStore.passwordUpdateRequest;

  return await method(fields).then((response) => {
    const { status, error } = response;
    if (status == "error" && error == "not_existing_user") {
      tpl_root.value.handleErrors([nuxtApp.$t.labels.signin_no_username_found]);
    } else if (status == "error") {
      tpl_root.value.handleErrors([nuxtApp.$t.labels.something_went_wrong]);
    }
    return response;
  });
}
</script>
